export type DiscussDestination = 'new' | 'source';

interface ResolveDiscussDestinationInput {
  requestedDestination: DiscussDestination;
  sourceConversationId?: string | null;
  sourceConversationAvailable: boolean;
  sourceConversationLoadSucceeded: boolean;
}

export function resolveDiscussDestination({
  requestedDestination,
  sourceConversationId,
  sourceConversationAvailable,
  sourceConversationLoadSucceeded,
}: ResolveDiscussDestinationInput): DiscussDestination {
  if (requestedDestination !== 'source') return 'new';
  if (!sourceConversationId || !sourceConversationId.trim()) return 'new';
  if (!sourceConversationAvailable) return 'new';
  if (!sourceConversationLoadSucceeded) return 'new';
  return 'source';
}

interface BuildRehomeMetadataInput {
  existingMetadata?: Record<string, unknown> | null;
  previousSourceConversationId?: string | null;
  destinationConversationId: string;
  userId: string;
  timestamp: string;
}

export function buildRehomeMetadata({
  existingMetadata,
  previousSourceConversationId,
  destinationConversationId,
  userId,
  timestamp,
}: BuildRehomeMetadataInput): Record<string, unknown> {
  const metadata =
    existingMetadata && typeof existingMetadata === 'object'
      ? { ...existingMetadata }
      : {};

  const previousSource = (previousSourceConversationId || '').trim();
  const existingOrigin =
    typeof metadata.originSourceConversationId === 'string'
      ? metadata.originSourceConversationId.trim()
      : '';
  const originSourceConversationId = existingOrigin || previousSource;

  return {
    ...metadata,
    ...(originSourceConversationId ? { originSourceConversationId } : {}),
    ...(previousSource ? { lastRehomeFromConversationId: previousSource } : {}),
    lastRehomeToConversationId: destinationConversationId,
    lastRehomedAt: timestamp,
    lastRehomedBy: userId,
  };
}

export function buildHandoffCleanupPath(
  pathname: string,
  queryInput: string | URLSearchParams
): string {
  const params =
    typeof queryInput === 'string'
      ? new URLSearchParams(queryInput)
      : new URLSearchParams(queryInput.toString());

  params.delete('artifact');
  params.delete('handoff');
  const nextQuery = params.toString();
  return nextQuery ? `${pathname}?${nextQuery}` : pathname;
}
